export default __webpack_public_path__ + "static/media/PE.3ff344b7.png";